const VersionCell = (params) => {
  if (!params.value) return null;

  return <div>v.{params.value}</div>;
};

export default VersionCell;
